/* eslint-disable react/button-has-type */
import React from 'react';
import ButtonMedium from 'components/common/Buttons/ButtonMedium';
import { ILocationFormData } from '../AddLocationButton';
import './styles.scss';
import { RxProviderOptions } from '../utils';

export interface IProps {
  handleSubmit: (e: any) => void;
  data: ILocationFormData;
}

const ConfirmAddLocationForm = (props: IProps) => {
  const { data, handleSubmit } = props;

  return (
    <div>
      <div styleName="container">
        <div styleName="item1">Location Name :</div>
        <div styleName="item2">{data.location.name}</div>
      </div>
      <div styleName="container">
        <div styleName="item1">Location Address :</div>
        <div styleName="item2">{data.location.addressLine1}</div>
      </div>
      <div styleName="container">
        <div styleName="item1">Rx Provider :</div>
        <div styleName="item2">{RxProviderOptions[0].name}</div>
      </div>
      <ButtonMedium
        buttonRole={'primary'}
        width={'340px'}
        margin={'15px 0'}
        handleClick={handleSubmit}
      >
        CREATE NEW LOCATION
      </ButtonMedium>
    </div>
  );
};

export default ConfirmAddLocationForm;
